import React, { memo, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import LoadingFallback from "../components/elements/LoadingFallback";
import { useSelector } from "react-redux";

const UserRoute = memo(function UserRoute({ children }) {
  const navigate = useNavigate();
  const { session } = useSelector((state) => state?.authProvider);

  useEffect(() => {
    if (session?.status === "unauthorized") {
      navigate("/");
    } else if (
      session?.status === "authorized" &&
      session?.user?.role?.toLowerCase() === "admin"
    ) {
      navigate("/admin/dashboard");
    } else if (
      session?.status === "authorized" &&
      session?.user?.role?.toLowerCase() === "recruiter"
    ) {
      navigate("/dashboard");
    }
  }, [session?.status, session?.user?.role?.toLowerCase(), navigate]);

  if (session?.status === "loading") {
    return <LoadingFallback />;
  }

  return session?.status === "authorized" &&
    session?.user?.role?.toLowerCase() === "user"
    ? children
    : null;
});

export default UserRoute;
